import React from 'react';
import { RouteObject, useRoutes } from 'react-router';
import { Navigate } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import ProtectedRouters from './ProtectedRoutes';

const Routes: React.FC = () => {
  return useRoutes([routes]);
};

const routes: RouteObject = {
  element: <MainLayout />,
  children: [
    {
      path: '/protected/*',
      element: <ProtectedRouters />,
    },
    {
      path: '/',
      element: <Navigate to="/protected" />,
    },
    {
      path: '/*',
      element: <h2>⚠ OOPS... Page not found! ⚠</h2>,
    },
  ],
};

export default Routes;
